module.exports = __webpack_public_path__ + "img/comunicado.981a8920.jpg";